// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2KLne","unreadBadge":"styles_unreadBadge__1qZ3i","modalContent":"styles_modalContent__1x3n6","modal":"styles_modal__2nIpH"};